import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref } from 'vue'
import {
  ApplicationPolicyInstallType,
  ApplicationPolicyAutoUpdateMode,
  ApplicationPolicyDelegatedScopes,
  ApplicationPolicyDefaultPermissionPolicy,
} from '@/generated/sdk'
import { formatPolicy } from './policy.utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'PackageForm',
  props: {
    config: {}
  },
  emits: ['update:config'],
  setup(__props: any, { emit }) {

const props = __props;

const installTypes = Object.values(ApplicationPolicyInstallType)
const autoUpdateModes = Object.values(ApplicationPolicyAutoUpdateMode)
const delegatedScopes = Object.values(ApplicationPolicyDelegatedScopes)
const defaultPermissionPolicy = Object.values(
  ApplicationPolicyDefaultPermissionPolicy,
)





const columns = [
  { field: 'property', header: 'Property' },
  { field: 'value', header: 'Value' },
]

const properties = ref([
  {
    id: 'packageName',
    property: 'Package name',
    value: undefined,
    type: 'text',
    placeholder: 'com.android.chrome',
  },
  {
    id: 'installType',
    property: 'Install type',
    value: undefined,
    type: 'dropdown',
    options: installTypes,
    placeholder: 'Select install type',
  },
  {
    id: 'defaultPermissionPolicy',
    property: 'Default permission policy',
    value: undefined,
    type: 'dropdown',
    options: defaultPermissionPolicy,
    placeholder: 'Select permission policy',
  },
  {
    id: 'autoUpdateMode',
    property: 'Auto update mode',
    value: undefined,
    type: 'dropdown',
    options: autoUpdateModes,
    placeholder: 'Select update mode',
  },
  {
    id: 'delegatedScopes',
    property: 'Delegated scopes',
    value: undefined,
    type: 'multiselect',
    options: delegatedScopes,
    placeholder: 'Select delegated scopes',
  },
  { id: 'disabled', property: 'Disabled', value: undefined, type: 'switch' },
  {
    id: 'permissionGrants',
    property: 'Permission grants',
    value: undefined,
    type: 'json',
    placeholder: JSON.stringify(
      [{ permission: 'android.permission.CAMERA', policy: 'GRANT' }],
      null,
      2,
    ),
  },
  {
    id: 'managedConfigurationTemplate',
    property: 'Managed configuration template',
    value: undefined,
    type: 'json',
    placeholder: JSON.stringify(
      { templateId: 'templateId', configurationVariables: { key: 'value' } },
      null,
      2,
    ),
  },
])

function onCellEditComplete(event) {
  let { data, newValue, field } = event
  data[field] = newValue
}

function addPackage() {
  const updateConfig = JSON.parse(props.config)
  if (!updateConfig.applications) updateConfig.applications = []

  const newPackage = {}
  // get only the properties that have a value
  properties.value.forEach(property => {
    if (property.value) newPackage[property.id] = property.value
  })

  updateConfig.applications.push(newPackage)
  emit('update:config', formatPolicy(updateConfig))
}

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimeTextarea = _resolveComponent("PrimeTextarea")!
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoColumn = _resolveComponent("DodoColumn")!

  return (_openBlock(), _createBlock(_component_DodoColumn, { grow: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        value: properties.value,
        "edit-mode": "cell",
        "table-class": "editable-cells-table",
        "table-style": "width: 100%",
        onCellEditComplete: onCellEditComplete
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
            return _createVNode(_component_PrimeColumn, {
              key: col.field,
              field: col.field,
              header: col.header,
              style: _normalizeStyle(`width: ${col.field === 'property' ? '40' : '60'}%`)
            }, {
              body: _withCtx(({ data, field }) => [
                (field === 'property')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(data[field]), 1)
                    ], 64))
                  : (data['type'] == 'text')
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 1,
                        modelValue: data[field],
                        "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                        placeholder: data['placeholder']
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                    : (data['type'] == 'json')
                      ? (_openBlock(), _createBlock(_component_PrimeTextarea, {
                          key: 2,
                          modelValue: data[field],
                          "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                          placeholder: data['placeholder'],
                          rows: "7"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                      : (data['type'] == 'dropdown')
                        ? (_openBlock(), _createBlock(_component_PrimeDropdown, {
                            key: 3,
                            modelValue: data[field],
                            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                            options: data['options'],
                            placeholder: data['placeholder']
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
                        : (data['type'] == 'multiselect')
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 4,
                              modelValue: data[field],
                              "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                              options: data['options'],
                              placeholder: data['placeholder'],
                              "max-selected-labels": 1
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "placeholder"]))
                          : (data['type'] == 'switch')
                            ? (_openBlock(), _createBlock(_component_InputSwitch, {
                                key: 5,
                                modelValue: data[field],
                                "onUpdate:modelValue": ($event: any) => ((data[field]) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                _createTextVNode(" template not found ")
                              ], 64))
              ]),
              _: 2
            }, 1032, ["field", "header", "style"])
          }), 64))
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_DodoButton, {
        variant: "solid",
        color: "info",
        onClick: addPackage
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Add application to policy ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})